<template>
  <el-dialog
    :title="'会议号: ' + checkForm.titleCode"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :before-close="cancelClick"
    class="checkDialogClass"
    width="500px">
    <div class="mainClass">
      <el-row class="publicRowClass">
        <el-col :span="24" class="publicTextClass">
          <span>悦学苑&nbsp;邀请您参加腾讯会议</span>
        </el-col>
      </el-row>
      <el-row class="publicRowClass">
        <el-col :span="24" class="publicTextClass">
          <span>会议主题:&nbsp;</span>
          <span>{{checkForm.subject}}</span>
        </el-col>
      </el-row>
      <el-row class="publicRowClass">
        <el-col :span="24" class="publicTextClass">
          <span>会议时间:&nbsp;</span>
          <span>{{checkForm.date}}(GMT+08:00)&nbsp;中国标准时间&nbsp;-&nbsp;北京</span>
        </el-col>
      </el-row>
      <el-row class="publicRowClass" v-if="checkForm.isRecurring === '1'">
        <el-col :span="24" class="publicTextClass">
          <span>重复周期:&nbsp;</span>
          <span>{{checkForm.recurrentDate}}，{{ checkForm.recurrentType }}</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-col :span="24">
          <div>
            <span class="publicTextClass" style="font-size: 13px;">点击链接入会，或添加至会议列表</span>
          </div>
          <a style="font-size: 13px;" :href="checkForm.joinUrl">{{checkForm.joinUrl}}</a>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px; margin-bottom: 0px;">
        <el-col :span="24">
          <span class="publicTextClass" style="font-size: 13px;">#腾讯会议:&nbsp;</span>
          <span style="font-size: 13px;">{{checkForm.meetingCode}}</span>
        </el-col>
      </el-row>
    </div>
    <!-- <div @click="copyClicks()" style="cursor: pointer;">复制</div> -->
    <div style="margin-top: 20px;">
      <el-row :gutter="10" style="margin-bottom: 0px;">
        <el-col :span="12" style="padding-right: 20px;">
          <el-button type="primary" style="width: 100%; border: 1px solid #d4d4d4; border-radius: 4px !important; color: #006FFF; font-size: 13px;" @click="copyAllClicks" class="copyAllClicks">复制全部信息</el-button>
        </el-col>
        <el-col :span="12" style="padding-left: 20px;">
          <el-button type="primary" style="width: 100%; border-radius: 4px !important; background-color: #006FFF; font-size: 13px;" @click="copyClicks" class="copyClicks">复制会议号和链接</el-button>
        </el-col>
      </el-row>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: Boolean,
    checkForm: Object
  },
  methods: {
    cancelClick() {
      this.$emit('checkDialogOk')
    },
    submitClick() {
      this.$emit('checkDialogOk')
    },
    copyClicks() {
      let copyTextArea = document.createElement('textarea')
      let str = `会议号: ${this.checkForm.meetingCode}\n会议链接: ${this.checkForm.joinUrl}`
      copyTextArea.value = str
      document.body.appendChild(copyTextArea)
      copyTextArea.select()
      try {
        let copyed = document.execCommand('copy')
        if (copyed) {
          document.body.removeChild(copyTextArea)
          console.log('复制成功')
        }
      } catch {
        console.log('复制失败')
      }
      this.$message({
        message: '会议邀请已复制到剪切板 ',
        center: true,
        type: 'copyAllClicks',
        customClass:'message',
      });

    },
    copyAllClicks() {
      let copyTextArea = document.createElement('textarea')
      let str = ''
      if (this.checkForm.isRecurring === '0') {
        str = `会议主题: ${this.checkForm.subject}\n会议时间: ${this.checkForm.date}(GMT+08:00) 中国标准时间 - 北京\n会议号: ${this.checkForm.meetingCode}\n会议链接: ${this.checkForm.joinUrl}`
      } else {
        str = `会议主题: ${this.checkForm.subject}\n会议时间: ${this.checkForm.date}(GMT+08:00) 中国标准时间 - 北京\n重复周期: ${this.checkForm.recurrentDate}，${this.checkForm.recurrentType}\n会议号: ${this.checkForm.meetingCode}\n会议链接: ${this.checkForm.joinUrl}`
      }
      copyTextArea.value = str
      document.body.appendChild(copyTextArea)
      copyTextArea.select()
      try {
        let copyed = document.execCommand('copy')
        if (copyed) {
          document.body.removeChild(copyTextArea)
          console.log('复制成功')
        }
      } catch {
        console.log('复制失败')
      }
      this.$message({
        message: '会议邀请已复制到剪切板 ',
        center: true,
        type: 'copyAllClicks',
        customClass:'message',
      });

    }
  }
}
</script>

<style scoped lang="scss">
 .copyAllClicks{
  background-color: #ffffff !important;
}
.copyAllClicks:hover{
  border: 1px solid #409EFF !important;
  background-color: #409EFF !important;
  color: #ffffff !important;
}
.copyClicks:hover{
 background-color: #409EFF !important;
}
.checkDialogClass {
  .mainClass {
    width: 100%;
    min-height: 100px;
    border: 1px solid rgb(212, 212, 212);
    padding: 15px;
    .publicRowClass {
      margin-bottom: 5px;
      .publicTextClass {
        font-size: 13px;
      }
    }
  }
   .el-dialog__header {
    text-align: center;
    .el-dialog__title {
      font-size: 14px;
    }
  }
   .el-dialog__close {
    display: inline;
  }
   .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 20px;
  }
}
.copyAllClicks .el-message .el-message__icon{
     display: none !important;
 }
</style>
<style lang="scss">
 .message{
     background: #000 !important;
     min-width: 200px!important;
     color: #fff !important;
     border:none !important;
 }
 .message i{
  display: none !important;
 }
</style>
